// Use custom express payments that mounts to existing containers
var expressPayments = require('../adyen/express/cart/expressPayments');

function init() {
  // Register all express payment button renderers
  expressPayments.renderExpressPaymentContainer();
  expressPayments.renderApplePayButton();
  expressPayments.renderPayPalButton();
  expressPayments.renderGooglePayButton();
  expressPayments.renderAmazonPayButton();

  // Initialize express payments
  expressPayments.init();
}

module.exports = {
  init: init
};